import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@alice-financial/pretext-ui'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import * as React from 'react'
import { AdminRoleInputs } from '../../companyProfile/AdminRoleInputs'
import { useOrg } from '../../organization/useOrg'

export const CompanyProfileStepTitle = 'Company Roles'

export const CompanyProfileDescription = () => (
  <Typography variant="body2" color="text.secondary">
    Set up admin roles and permissions
  </Typography>
)

// Wrapper component that uses the core company profile components
export const CompanyProfileComponent = () => {
  const org = useOrg()

  if (!org) return null

  return (
    <>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Choose who we should contact for each role so we can support you faster.
      </Typography>
      <AdminRoleInputs />
    </>
  )
}

export const CompanyProfileInstructions = () => (
  <>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      If one person covers multiple roles, add them once and check the additional roles. You can update this
      anytime.
    </Typography>

    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
      Requirements
    </Typography>
    <List dense>
      <ListItem disableGutters>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <CheckCircleOutlineIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText primary="Name and email address for each person" />
      </ListItem>
    </List>

    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
      Key Info
    </Typography>
    <List dense>
      <ListItem disableGutters>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <LightbulbOutlinedIcon fontSize="small" color="warning" />
        </ListItemIcon>
        <ListItemText primary="Each person can be assigned to multiple roles" />
      </ListItem>
      <ListItem disableGutters>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <LightbulbOutlinedIcon fontSize="small" color="warning" />
        </ListItemIcon>
        <ListItemText primary="Each person can be assigned to multiple roles" />
      </ListItem>
      <ListItem disableGutters>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <LightbulbOutlinedIcon fontSize="small" color="warning" />
        </ListItemIcon>
        <ListItemText primary="Only one assignment is required, but adding more helps us support you better" />
      </ListItem>
    </List>
  </>
)
